<template>
	<div class='lands'>
		<div v-for='(species, species_i) in vbList' class='species-block' :key="species_i">
			<span class='title'>{{ species.info.species + (species.info.layer == 11 ? ' (единичные деревья':  ` (ярус ${species.info.layer}`) + `, поколение ${species.info.gen})`}}</span>
			<button @click='enableEditMode(species_i)'>Редактировать</button>
			<table class='table-distribution table-common' :class='{ edited: editedSpeciesI === species_i }'>
				<thead>
					<tr>
						<th></th>
						<th>I</th>
						<th>II</th>
						<th>III</th>
						<th>IV</th>
						<th>Свежий сухостой</th>
						<th>Свежий ветровал</th>
						<th>Свежий бурелом</th>
						<th>Старый сухостой</th>
						<th>Старый ветровал</th>
						<th>Старый бурелом</th>
						<!-- <th>Аварийные деревья</th> -->
						<th>Всего</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>Общее</td>
						<td v-for='state_cat in getSpeciesValues(species.info)' :key="`${species_i}_${state_cat.state_cat_id}`">
							<input type='number' v-model='state_cat.common' class='distr-input'>
						</td>
						<td>{{ getTotalCommon(species.info) }}</td>
					</tr>
					<tr>
						<td>Рубка</td>
						<td v-for='state_cat in getSpeciesValues(species.info)' :key="`${species_i}_${state_cat.state_cat_id}`">
							<input type='number' v-model='state_cat.felling' class='distr-input' :disabled='is5Cat(state_cat.state_cat_id) || isFelling(species.damages, state_cat.state_cat_id)'>
						</td>
						<td>{{ getTotalFelling(species.info) }}</td>
					</tr>	
				</tbody>
			</table>

			<div class='values-btn-row' v-if='editedSpeciesI === species_i'>
				<div>
					<button @click='disableEditMode'>Отмена</button>
					<button @click='save(species)'>Сохранить</button>
				</div>
			</div>

			<div class='damages-block-outer'>
				<VbDamages :current-species='species'/>
			</div>
		</div>


	</div>
</template>

<script>
	import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

	import VbDamages from './Recount__bvSheetDamages';

	export default {
		name: 'RecountVbSheet',
		components: {
			VbDamages
		},
		data: () => ({
			values: {},

			values2: [],

			editedSpeciesI: -1,
		}),

		computed: {
			...mapState('selectedLpo/recount', {
				vbList: state => state['vbList']
			}),
		},

		methods: {
			getSpeciesValues(species) {
				const finded = this.values2.find(value => {
					return species.species_id === value.species.species_id &&
								 species.layer === value.species.layer &&
								 species.gen === value.species.gen;
				});
				return finded.values;
			},
			addSpeciesValue(species) {

			},

			enableEditMode(species_i) {

				this.formValues();
				this.editedSpeciesI = species_i;
			},
			disableEditMode() {
				this.editedSpeciesI = -1;
				this.formValues();
			},

			getTotalCommon(species) {
				let total = 0;
				for (let i = 0; i < 10; ++i) {
					// total += +this.values[species.species_id][i].common;
					total += +this.getSpeciesValues(species)[i].common;
				}
				return String(total);
			},
			getTotalFelling(species) {
				let total = 0;
				for (let i = 0; i < 10; ++i) {
					// total += +this.values[species.species_id][i].felling;
					total += +this.getSpeciesValues(species)[i].felling;
				}
				return String(total);
			},

			save(species) {
				let total = 0;
				let total_felling = 0;
				// for (let item of this.values[species.species_id]) {
					// console.log(this.getSpeciesValues(species));
					// return;
				for (let item of this.getSpeciesValues(species.info)) {
					// console.log(item);

					total += +item.common;
					total_felling += +item.felling;

				}
				
				if (total !== 100 && total !== 0) {
					console.log('wrong', total);
					this.$toast.open({
						message: 'Неверное распределение по категориям. Общий процент: ' + total + '%',
						type: 'error'
					});
					return;
				}

				if (total_felling > 100) {
					console.log('wrong', total);
					this.$toast.open({
						message: 'Неверное распределение в рубку: ' + total_felling + '%',
						type: 'error'
					});
					return;
				}

				const temp = {
					species: species.info,
					// values: this.values[species.species_id]
					values: this.getSpeciesValues(species.info)
				};
				this.saveVb(temp).then(res => {
					this.updateVbList().then(res => this.formValues());
					//this.updateVbDamageList();
					this.disableEditMode();

				});
			},

			formValues() {
				for (const species of this.vbList) {
					const temp = {
						species: species.info,
						values: this.formValuesForSpecies(species)
					};
					this.values2.push(temp);
				}
			},
			formValuesForSpecies(vbItem) {
				const temp = new Array(10);
				for (let i = 0; i < 10; i++) {
					temp[i] = { state_cat_id: (i+1).toString(), common: '0', felling: '0' };
				} 

				for (const state_cat of vbItem.state_cats) {
					const finded = temp.find(item => item.state_cat_id === state_cat.state_cat_id);
					finded.common = state_cat.trees_proc;
					finded.felling = state_cat.felling_proc;
				}
				return temp;
			},

			is5Cat(state_cat_id) {
				if (state_cat_id === '5' ||
						state_cat_id === '6' ||
						state_cat_id === '7' ||
						state_cat_id === '8' ||
						state_cat_id === '9' ||
						state_cat_id === '10') {
					return true;
				}
				return false;
			},
			isFelling(damages, state_cat_id) {
				const finded = damages.find(damage => damage.state_cat_id === state_cat_id && damage.is_felling);
				return !finded ? true : false;
			},

			...mapActions('selectedLpo/recount', [
				'saveVb',
				'updateVbList',
			])

		},

		created() {
			this.formValues();
		}
	};
</script>

<style scoped src='@/style/table.css'></style>
<style scoped src='@/style/button.css'></style>

<style scoped>
	.species-block {
		margin-bottom: 50px;
	}
	.species-block .title {
		font-size: 16px;
		display: inline-block;
		margin-bottom: 10px;
		margin-right: 10px;
		font-weight: bold;
	}

	.table-distribution input {
		width: 100%;
		text-align: center;
	}

	.table-distribution:not(.edited) .distr-input {
		background-color: white;
		border: 2px solid white;

	}
</style>